import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { PenOfferScopeDto } from 'models/pen/PenOfferScope';

@autoinject
export class PenOfferScopeService {
  constructor(private client: NetlogHttpClient) {}

  async getPenOfferScope(id: number) {
    return await this.client.get<PenOfferScopeDto>({
      url: `api/pen-offer-scopes/${id}`,
      model: PenOfferScopeDto,
    });
  }

  async updatePenOfferScope(id: number, data: PenOfferScopeDto) {
    return await this.client.patch({
      data,
      url: `api/pen-offer-scopes/${id}`,
    });
  }
}
